import { ReportRecipientStatus } from "app/containers/WeeklyCheckInMonitor/types";

export const DRAWER_WIDTH = "w-full max-w-[650px]";
export const SECTION_DISPLAY_LIMIT = 10;

export const STATUS_DOT: Record<ReportRecipientStatus, string> = {
  qualified_by_rules: "bg-green-500",
  included_override: "bg-green-500",
  excluded: "bg-red-500",
  below_threshold: "bg-charcoal-40",
  not_included: "bg-charcoal-40",
};

export type ActionType =
  | "remove"
  | "remove_manual_add"
  | "exclude"
  | "include"
  | "re_include"
  | "add"
  | "info";

export const ACTION_CONFIG: Record<
  ActionType,
  {
    label: string;
    variant: "secondary-blue" | "tertiary-error" | "secondary-gray";
    className?: string;
  }
> = {
  remove: {
    label: "Remove",
    variant: "tertiary-error",
    className: "border-red-500 border-[1px]",
  },
  remove_manual_add: {
    label: "Remove manual add",
    variant: "tertiary-error",
    className: "border-red-500 border-[1px]",
  },
  exclude: {
    label: "Exclude",
    variant: "tertiary-error",
    className: "border-red-500 border-[1px]",
  },
  include: { label: "Include", variant: "secondary-blue" },
  re_include: { label: "Re-include", variant: "secondary-blue" },
  add: { label: "Add", variant: "secondary-blue" },
  info: { label: "Receives Senior Manager Check-in Report", variant: "secondary-gray" },
};

export interface NonRecipientUser {
  userAccountId: number;
  firstName: string;
  lastName: string;
  jobTitle?: string;
}

export interface SpecificPeopleSections<T> {
  mode: "specific_people";
  manuallyAdded: T[];
  qualified: T[];
}

export interface AllWhoQualifySections<T> {
  mode: "all_who_qualify";
  manuallyAdded: T[];
  eligibleByRules: T[];
  manuallyExcluded: T[];
  belowThreshold: T[];
}

export type Sections<T> = SpecificPeopleSections<T> | AllWhoQualifySections<T>;
